import ProductEventsSetup from './product/PluginSetup'

export default {
  install( molten ) {
    ProductEventsSetup.install( molten )
  }
}
